import React from 'react';
import Text from '../components/Text';
import Chapter from '../components/Chapter';

const url = 'https://app.nos.nl/social-credit-score/index.html';
const text = 'Over twee jaar krijgt íedere Chinees een Social Credit Score van de overheid. Hoe voorbeeldiger je je gedraagt, hoe hoger je score. Hoe gaat dat? Ervaar het zelf in onze game:';

const Footer = ({
  id,
  trackEvent,
}) => (
  <Chapter
    id={id}
    onEnter={() => trackEvent(id)}
  >
    <div className="footer">
        <div className="footer__section">
          <h3>Deel dit verhaal</h3>
          <div className="footer__social">
            <a target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} className="button">Facebook</a>
            <a target="_blank" href={`http://twitter.com/share?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`} className="button">Twitter</a>
          </div>
        </div>
        <div className="footer__section">
          <h3>Verantwoording</h3>
          <Text>De situatie in het verhaal is fictief. Het beeldmateriaal komt uit de reportage van Nieuwsuur. Sui is gesproken door Nieuwsuur. Maar de situatie is verzonnen en gaat niet over haar. Dit verhaal is gebaseerd op de reportage van Nieuwsuur en gesprekken met Rogier Creemers, onderzoeker en jurist van de Universiteit Leiden.</Text>
        </div>
        <div className="footer__section">
          <h3>Colofon</h3>
          <Text>
            <strong>Redactie</strong>
            Stephan Vegelien
          </Text>
          <Text>
            <strong>Design & code</strong>
            Tom Dalenberg<br/>
            Stijn Postmus<br />
            Nour Abdullaa<br/>
          </Text>
          <Text>
            <strong>Met dank aan</strong>
            Dr. R.J.E.H. Creemers (Universiteit Leiden)<br />
            Marieke de Vries (correspondent Oost-Azië)<br />
            Lorenzo Fränkel (Nieuwsuur)
          </Text>
        </div>
    </div>
  </Chapter>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/chapters/Footer.js